// extracted by mini-css-extract-plugin
export var activeImage = "flipAvatar-module--activeImage--wq97b";
export var flipAvatar = "flipAvatar-module--flipAvatar--yAXBJ";
export var flipImage = "flipAvatar-module--flipImage--202XT";
export var flipInner = "flipAvatar-module--flipInner--3bq7n";